import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { Column, ColumnKeys, COLUMNS, FILTERS, PREDEFINED_FILTERS_KEYS } from '../types';
import {
  WEB_COMPONENT_GRID_VIEW,
  WEB_COMPONENT_XDR_SEARCH_APP,
  WEB_COMPONENT_XDR_SEARCH_TAB_PANEL,
} from '../../../webcomponents.constants';
import { GridViewWebComponent } from '../../../grid/gridView';
import { XdrSearchResultsPanelGzDataProvider } from '../dataProvider/XdrSearchResultsPanelGzDataProvider';
import { ViewType } from '../../../grid/gridView/types';
import { dateRenderer } from '@nirvana/shared/common';
import { alertIncidentNumberRenderer, endpointRenderer, countDefaultValueRenderer, sanitizePathValueRenderer } from './customGridRenderers';

export class XdrSearchResultsPanelView extends BaseWebComponentView {
  getDomElements() {
    this.dom.$wrapper = this.shadow.querySelector('.wrapper');
    this.dom.$gridView = this.shadow.querySelector(WEB_COMPONENT_GRID_VIEW) as GridViewWebComponent<Column, ColumnKeys>;

    if (this.dom.$gridView.injectDependencies) {
      this.dom.$gridView.injectDependencies(this.dependencies);
      this.dom.$gridView.start().then().catch(console.error);
    }

    this.getTranslations();
    this.setTranslatedStrings();
  }

  get allTranslations() {
    return this.translations;
  }

  getTranslations() {
    this.translations = this.stringsTranslator.getXdrSearchStrings();
  }

  setTranslatedStrings() {}

  buildView(data: any) {
    if (!data) {
      this.dom.$wrapper.innerHTML = '';
      return;
    }

    this.buildGridView(data);
    this.setElementClass(this.dom.$gridView, 'hidden');
  }

  private buildGridView(data: any) {
    const view = {
      id: '12345',
      name: 'Default view',
      type: ViewType.DEFAULT,
      filters: FILTERS,
      displayedColumns: COLUMNS,
      pageSize: 20,
      selectedTargets: [
        {
          companyId: 'vagrant',
          companyName: 'Vagrant',
        },
      ],
      compactView: false,
    };

    this.dom.$gridView.propertiesSet = false;
    this.dom.$gridView.dataProvider = new XdrSearchResultsPanelGzDataProvider(
      this.dependencies,
      data.response.allColumns
    );

    const gridSettingsPanelParentTab = window.document
      .querySelector(WEB_COMPONENT_XDR_SEARCH_TAB_PANEL)
      ?.shadowRoot?.querySelector('#sideMenuSettingsContainer');
    const gridSettingsPanelParent = window.document
      .querySelector(WEB_COMPONENT_XDR_SEARCH_APP)
      ?.shadowRoot?.querySelector('.wrapper');

    this.dom.$gridView.columnRenderers = {
      [ColumnKeys.EVENT_TIME]: dateRenderer.bind(this),
      [ColumnKeys.OTHER_HOSTNAME]: endpointRenderer.bind(this),
      [ColumnKeys.ALERT_INCIDENT_NUMBER]: alertIncidentNumberRenderer.bind(this),
      [ColumnKeys.OTHER_COUNT]: countDefaultValueRenderer.bind(this),
      [ColumnKeys.PROCESS_PATH]: sanitizePathValueRenderer.bind(this),
      [ColumnKeys.OTHER_SCRIPT]: sanitizePathValueRenderer.bind(this),
      [ColumnKeys.NETWORK_HOSTNAME]: sanitizePathValueRenderer.bind(this),
      [ColumnKeys.NETWORK_URI]: sanitizePathValueRenderer.bind(this),
      [ColumnKeys.PROCESS_COMMAND_LINE]: sanitizePathValueRenderer.bind(this),
      [ColumnKeys.PROCESS_BUFFER]: sanitizePathValueRenderer.bind(this),
      [ColumnKeys.PROCESS_TARGET_PATH]: sanitizePathValueRenderer.bind(this),
      [ColumnKeys.PROCESS_INJECTION_WRITER_PATH]: sanitizePathValueRenderer.bind(this),
      [ColumnKeys.PROCESS_INJECTION_TARGET_PATH]: sanitizePathValueRenderer.bind(this),
      [ColumnKeys.FILE_PATH]: sanitizePathValueRenderer.bind(this),
      [ColumnKeys.FILE_OLD_PATH]: sanitizePathValueRenderer.bind(this),
      [ColumnKeys.FILE_URL]: sanitizePathValueRenderer.bind(this),
      [ColumnKeys.FILE_DESTINATION_URL]: sanitizePathValueRenderer.bind(this),
      [ColumnKeys.RESOURCE_PATH]: sanitizePathValueRenderer.bind(this),
      [ColumnKeys.RESOURCE_URL]: sanitizePathValueRenderer.bind(this),
      [ColumnKeys.RESOURCE_APP_ADDRESS]: sanitizePathValueRenderer.bind(this),
      [ColumnKeys.REGISTRY_KEY]: sanitizePathValueRenderer.bind(this),
      [ColumnKeys.REGISTRY_VALUE]: sanitizePathValueRenderer.bind(this),
      [ColumnKeys.EMAIL_PATH]: sanitizePathValueRenderer.bind(this),
    };
    this.dom.$gridView.defaultViewProps = view;
    this.dom.$gridView.viewId = view.id;
    this.dom.$gridView.allColumnDetails = data.response.allColumns;
    this.dom.$gridView.columns = view.displayedColumns;
    this.dom.$gridView.filters = view.filters;
    this.dom.$gridView.predefinedFiltersKeys = PREDEFINED_FILTERS_KEYS;
    this.dom.$gridView.isCompactViewChecked = view.compactView;
    this.dom.$gridView.defaultViewProps = data.response.defaultViewProps;
    this.dom.$gridView.pageSize = view.pageSize;
    this.dom.$gridView.sideMenuParent = gridSettingsPanelParentTab || gridSettingsPanelParent;
    this.dom.$gridView.enableRowClickEvent = true;
    this.dom.$gridView.propertiesSet = true;
  }
}
